// extracted by mini-css-extract-plugin
export default {"nutrition-row-border":"utils-module__nutrition-row-border__a6cIR","nutrition-row-border-thick":"utils-module__nutrition-row-border-thick__V88na"};